import { Form } from "react-bootstrap";
import { CrudInputModel } from "./crudInputModel";
import { z } from "zod";
import { RequiredAsterisks } from "../../Asterisks/requiredAsterisks";

export const CrudEnumInput = ({
  validationSchema,
  form,
  name,
  label,
  disabled,
  t,
  required,
}: CrudInputModel) => {
  const options =
    validationSchema instanceof z.ZodOptional ||
    validationSchema instanceof z.ZodDefault
      ? validationSchema._def.innerType._def.values
      : validationSchema._def.values;

  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        return (
          <Form.Group className="mb-3">
            <Form.Label>
              {label} {required && <RequiredAsterisks />}
            </Form.Label>
            <Form.Select
              id={field.name}
              key={field.name}
              name={field.name}
              value={field.state.value as string}
              onBlur={field.handleBlur}
              onChange={(e) => field.handleChange(e.target.value)}
              isInvalid={field.state.meta.errors.length > 0}
              disabled={disabled}
            >
              <option>- {t("Nothing")} -</option>
              {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                options.map((option: string) => (
                  <option key={option} value={option}>
                    {t(`crud.${name}.${option}`)}
                  </option>
                ))
              }
            </Form.Select>
            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
};
